import { render, staticRenderFns } from "./HolidayAnimation.vue?vue&type=template&id=08bc05cd"
import script from "./HolidayAnimation.vue?vue&type=script&lang=js"
export * from "./HolidayAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports